import React from 'react'
import { StatusBadge } from '../Badges'
import CheckBox from '../CheckBoxes'

import LinkColumn from './components/LinkColumn'

const StatusCell = ({ status, className }) => {
  return (
    <td className={className}>
      <StatusBadge status={status || 'active'} />
    </td>
  )
}

const SelectorCell = ({ className }) => {
  return (
    <td className={className + ' selector'}>
      <CheckBox checked={false} />
    </td>
  )
}

const displayClass = (hideFor) => {
  if (!hideFor) {
    return ''
  }

  let className = 'hidden'

  // className += hideFor.phone ? ' phone' : ''
  // className += hideFor.tablet_portrait ? ' tablet' : ''

  if (hideFor.phone) {
    className += ' phone'
  }

  if (hideFor.tablet_portrait) {
    className += ' tablet'
  }

  return className
}

const TableHeader = ({ column }) => {
  /*
    If column is a selector.
    Then we add a checkbox to the header
    TODO: Add methods to handle select
   */
  if (column.accessor === 'selector') {
    return (
      <th className={displayClass(column.hide_for) + ' selector'}>
        <CheckBox checked={false} />
      </th>
    )
  } else {
    return (
      <th className={displayClass(column.hide_for)}>
        {column.Header}
      </th>
    )
  }
}

const TableCell = ({ column, row }) => {
  const className = displayClass(column.hide_for)

  switch (column.accessor) {
    /*
      If accessor is status
      Then we style the status as a badge
     */
    case 'status':
      return (<StatusCell status={row.status} className={className} />)
    /*
      If column is a selector.
      Then we add a checkbox to the header
      TODO: Add methods to handle select
   */
    case 'selector':
      return (<SelectorCell className={className} />)
    default:
      return (
        <td className={className} style={column.style}>
          {row[column.accessor]}
        </td>
      )
  }
}

const TableCustom = ({ columns, data, config, url }) => {
  const tableClass = config && config.class_name ? config.class_name : ''
  return (
    <table className={'table ' + tableClass}>
      <thead>
        <tr>
          {columns.map((column) =>
            <TableHeader key={column.accessor} column={column} />
          )}
          <th className='hidden phone' />
        </tr>
      </thead>
      <tbody>
        {data.map((row) =>
          <tr key={row.id}>
            {columns.map((column) =>
              <TableCell key={column.accessor} column={column} row={row} />
            )}
            <td className='hidden phone'>
              <LinkColumn url={url} obj={row} />
            </td>
          </tr>
        )}
      </tbody>
    </table>
  )
}

export default TableCustom
